//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BooleanRegionSelect",0,"GeometricUtilities.BooleanRegionSelect",0],[0,"ConvertToSew",1,0],[0,"CopyTargets",1,0],[0,"CopyTools",1,0],[0,"Operation",1,0],[0,"RemoveTargetVoids",1,0],[0,"RetainTarget",1,0],[0,"RetainTool",1,0],[0,"Target",1,"Body",0],[0,"TargetBodyCollector",1,"ScCollector",0],[1,"Targets",0,"SelectBodyList",1],[0,"Tolerance",1,0],[0,"Tolerance1",1,0],[0,"ToolBodyCollector",1,"ScCollector",0],[0,"ToolBodyCollector1",1,"ScCollector",0],[1,"Tools",0,"SelectDisplayableObjectList",1]],[],[]];
SPLM.Features.BooleanBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BooleanBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;